module.exports = __webpack_public_path__ + "media/day/392-6f940a9d.svg";